import { BaseEnum } from '../../../../enums/baseEnum';

const listActionPlanStatus: Array<ActionPlanStatus> = [];

export class ActionPlanStatus extends BaseEnum {
  static PENDING = new ActionPlanStatus(1, 'PENDING', 'Pendente');
  static IN_PROGRESS = new ActionPlanStatus(2, 'IN_PROGRESS', 'Em andamento');
  static COMPLETED = new ActionPlanStatus(3, 'COMPLETED', 'Concluído');

  constructor(
    public id: number,
    public value: string,
    public label: string
  ) {
    super(id, value, label);
    listActionPlanStatus.push(this);
  }

  public static get(value: string | number): ActionPlanStatus {
    if (typeof value === 'string') {
      return this.getBy(value);
    }

    return this.getById(value);
  }

  public static buildListEnum(): Array<BaseEnum> {
    return listActionPlanStatus;
  }
}
